import { CaseReportSignature } from "pwapi";

import { USER_SIGNATURES_SUCCESS } from "../actions/constants";

export interface UserSignatures {
  [key: number]: CaseReportSignature[];
}

const reducer = (
  state: UserSignatures | null = null,
  action: any
): UserSignatures | null => {
  switch (action.type) {
    case USER_SIGNATURES_SUCCESS:
      return {
        ...state,
        [action.args.userId]: action.payload.response.results,
      };
    default:
      return state;
  }
};

export default reducer;
